import { api } from "@/api";
import { FullMatchDto } from "./getFullMatches";

export const manualFinalizeMatch = async (matchId: string): Promise<FullMatchDto> => {
  const res = await api.client.post(`/matches/${matchId}/manual-finalize`);
  return res.data;
};
